import {useEffect, useState} from 'react';

// Подсказка, "живущая" на случайных тиках 3-8 сек (как плашка-подсказка в
// LobbyPage) и сохраняющаяся в localStorage: при ремаунте компонента свежее
// (< 1 мин) значение берется за базу, иначе генерируется новое случайное
// в тех же границах. Общий ключ — чтобы главное меню (кнопка "Рейтинговый
// матч") и экран ожидания рейтингового матча (RankMatchWaiting) показывали
// одно и то же "среднее время ожидания"
export const RANKED_SEARCH_HINT_STORAGE_KEY = 'mainMenuRankedSearchHint';

const SEARCH_HINT_MAX_AGE_MS = 60 * 1000;

const randomIntInclusive = (min, max) => min + Math.floor(Math.random() * (max - min + 1));

const readStoredHintValue = (storageKey) => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.value !== 'number' || typeof parsed?.updatedAt !== 'number') return null;
    if (Date.now() - parsed.updatedAt >= SEARCH_HINT_MAX_AGE_MS) return null;
    return parsed.value;
  } catch (e) {
    return null;
  }
};

const writeStoredHintValue = (storageKey, value) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify({value, updatedAt: Date.now()}));
  } catch (e) {
    // localStorage недоступен (приватный режим и т.п.) — просто не сохраняем
  }
};

export const useDriftingSearchHint = (storageKey, min, max, deltaMin, deltaMax) => {
  const [value, setValue] = useState(() => {
    const stored = readStoredHintValue(storageKey);
    if (stored !== null) return stored;
    const initial = randomIntInclusive(min, max);
    writeStoredHintValue(storageKey, initial);
    return initial;
  });

  useEffect(() => {
    let timeoutId;
    const scheduleNextChange = () => {
      timeoutId = setTimeout(() => {
        setValue((prevValue) => {
          const delta = randomIntInclusive(deltaMin, deltaMax) * (Math.random() < 0.5 ? -1 : 1);
          const nextValue = Math.min(max, Math.max(min, prevValue + delta));
          writeStoredHintValue(storageKey, nextValue);
          return nextValue;
        });
        scheduleNextChange();
      }, 3000 + Math.floor(Math.random() * 5001));
    };
    scheduleNextChange();
    return () => clearTimeout(timeoutId);
  }, [storageKey, min, max, deltaMin, deltaMax]);

  return value;
};
